@if (orientation == 'x') {
  <svg:g
    class="x"
    attr.transform="translate(0, {{ dimensions.boundedHeight }})"
    >
    <svg:line class="axis" [attr.x2]="dimensions.boundedWidth"></svg:line>
      @for (tick of ticks; track tick) {
        <svg:text
          class="tick"
        [ngStyle]="{
            transform: [
                'translate(',
                scale(tick),
                'px, 10px)',
                'rotate(-45deg)'
            ].join('')
        }"
          >
          {{ formatTick(tick) }}
          </svg:text>
        }
        @for (tick of ticks; track tick) {
          <svg:line
            class="tick"
            [attr.y1]="-5"
            [attr.y2]="1"
            attr.transform="translate({{ scale(tick) }})"
            ></svg:line>
          }
          @if (label) {
            <svg:text
              class="label"
              attr.transform="translate({{ dimensions.boundedWidth / 2 }}, 40)"
              >
              {{ label }}
              </svg:text>
            }
            </svg:g>
          }
          @if (orientation == 'y') {
            <svg:g class="y">
              <svg:line class="axis" [attr.y2]="dimensions.boundedHeight"></svg:line>
                @for (tick of ticks; track tick) {
                  <svg:text
                    class="tick"
                    attr.transform="translate(-16, {{ scale(tick) }})"
                    >
                    {{ formatTick(tick) }}
                    </svg:text>
                  }
                  @for (tick of ticks; track tick) {
                    <svg:line
                      class="tick"
                      x1="-1"
                      x2="2"
                      attr.transform="translate(0, {{ scale(tick) }})"
                      ></svg:line>
                    }
                    @if (label) {
                      <svg:text
                        class="label"
        [ngStyle]="{
            transform: [
                'translate(-50px, ',
                dimensions.boundedHeight / 2,
                'px) rotate(-90deg)'
            ].join('')
        }"
                        >
                        {{ label }}
                        </svg:text>
                      }
                      </svg:g>
                    }
